<template>
  <span class="pl-0" style="display: inline">
    <font-awesome-icon v-if="!region || region.type === 'default'" icon="globe"
                       transform="shrink-4"></font-awesome-icon>
    <img v-else-if="region.type === 'lang'" :alt="region.flag"
         :src="'https://silkplm.com/wp-content/uploads/flags/' + region.flag + '.webp'"
         style="width: 15px; height: 12px">
    <span v-else>
      <font-awesome-icon icon="globe" transform="shrink-2"></font-awesome-icon>
        <img :alt="region.flag" :src="'https://silkplm.com/wp-content/uploads/flags/' + region.flag + '.webp'"
             style="width: 15px; height: 12px;">
    </span>

          <b-button
              v-if="regionCode === 'def' && !openFromGrid && mode !== 'NEW' && !isCurrencyRenderer"
              :disabled="translationInProgress || readOnly"
              variant="outline-danger" @click="translateFieldValue"  size="sm"
                    style="width: 22px;
                height: 18px;
                padding-left: 1px;
                padding-top: 0px;">
        <font-awesome-icon icon="language" transform="shrink-3 up-2" ></font-awesome-icon>
      </b-button>


  </span>
</template>

<script>

import ValidatedField from "@/validation/ValidatedField";
import Rpc from "@/Rpc";
import {cloneClassInstance} from "@/utils/Objects";
import FormFieldConfig from "@/server/com/silkplm/engine/forms/schema/definition/FormFieldConfig";
import FormModel from "@/components/forms/FormModel";

export default {
  name: "RegionSmIcon",
  async beforeMount() {
  },
  async mounted() {
    this.isCurrencyRenderer = this.validatedField.isDecimalWithCurrencyRenderer();
    this.parentForm?.afterSave(async () => {
      await this.reloadPendingTranslationsAfterSave();
    });
  },
  methods: {
    async reloadPendingTranslationsAfterSave() {
      if (this.isCurrencyRenderer) {
        return;
      }
      let fieldName = this.fieldConfig.fieldName;
      let originalSource = this.parentForm.originalSource;
      if (this.entityInstance) {
        if (this.entityInstance[fieldName] !== originalSource[fieldName]) {
          if (this.parentForm.originalSource?.__supplement__) {
            this.translationInProgress = this.parentForm.originalSource?.__supplement__?.translationInProgress;
          } else {
            let entity = await Rpc.Forms.getExtendedEntity(this.parentForm.formConfig.formClassLong, this.parentForm.originalSource.id);
            this.translationInProgress = entity.__supplement__?.translationInProgress;
          }
        }
      } else {
        let entity = await Rpc.Forms.getExtendedEntity(this.parentForm.formConfig.formClassLong, this.parentForm.originalSource.id);
        this.translationInProgress = entity.__supplement__?.translationInProgress;
      }
      this.entityInstance = cloneClassInstance(originalSource);
    },

    async checkIfTranslationsIsCorrect() {
      let baseLanguage = SessionManager.defaultCustomerLanguageCode;
      let keys = Object.keys(this.initializedTranslations);
      let firstLanguage = keys[0];
      let firstTranslatedVal = this.initializedTranslations[firstLanguage];
      let translatedVal = await Rpc.Regions.translate(baseLanguage, firstLanguage,
          this.validatedField.value).lock();
      if (firstTranslatedVal !== translatedVal) {
        this.differentTranslationsSaved = true;
      }
    },

    setRegionCode(val) {
      this.region = SessionManager.getRegionByCode(val)
    },
    async translateFieldValue() {
      if (!this.validatedField.translations) {
        return;
      }
      if(!await DialogManager.yesNo("Automatic translation", "Do you like to automatically translate field value and replace existing translations?")){
        return;
      }

      let toLangList = Object.keys(this.validatedField.translations);
      toLangList = _.filter(toLangList, (element) => !element.startsWith('r_'));
      let baseLanguage = SessionManager.defaultCustomerLanguageCode;
      let newAssignedTranslations = await Rpc.Regions.translateToMultiLang(baseLanguage, toLangList, this.validatedField.value).lock();
      for (const [key, value] of Object.entries(newAssignedTranslations)) {
        if (!key.includes("r_")) {
          this.validatedField.translations[key] = value;
        }
      }
      this.inputValue = false;
      this.locked = true;
      this.differentTranslationsSaved = false;
    }
  },
  props: {
    regionCode: {default: 'def'},
    readOnly: {type: Boolean, default: false},
    originalNameChanged: {default: false},
    validatedField: {type: ValidatedField, default: null},
    openFromGrid: {default: false},
    mode: {default: null},
    fieldConfig: {type: FormFieldConfig, default: null},
    formField: {type: ValidatedField, default: null},
    parentForm: {type: FormModel}
  },
  watch: {
    regionCode(val) {
      this.setRegionCode(val);
    },
    "validatedField.translations": async function (val) {
      if (!this.isCurrencyRenderer && Object.keys(val)?.length) {
        if (!this.initializedTranslations) {
          this.initializedTranslations = cloneClassInstance(this.validatedField.translations);
          this.translationInProgress = this.parentForm.originalSource?.__supplement__?.translationInProgress;
          this.entityInstance = cloneClassInstance(this.parentForm.originalSource);
          await this.checkIfTranslationsIsCorrect();
        }
      }
    },
  },

  data() {
    return {
      region: SessionManager.getRegionByCode('def'),
      inputValue: false,
      locked: false,
      initializedTranslations: null,
      differentTranslationsSaved: false,
      isCurrencyRenderer: false,
      translationInProgress: false,
      entityInstance: null,
    }
  }
}
</script>
